const plugin = {
  install(Vue) {
    Vue.filter('labelFrom', function (value, options = []) {
      const match = options.find(item => value === item.value)
      return match ? match.label : value
    })
  }
}

export default plugin
